// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CopyrightTwoToneSvg from "@ant-design/icons-svg/es/asn/CopyrightTwoTone";
import AntdIcon from '../components/AntdIcon';

var CopyrightTwoTone = function CopyrightTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CopyrightTwoToneSvg
  }));
};

CopyrightTwoTone.displayName = 'CopyrightTwoTone';
export default React.forwardRef(CopyrightTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CopyrightTwoTone.js
// module id = 883
// module chunks = 0